import React, {Component} from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Row, Col, Divider, Upload, Select } from 'antd';

const {Option} = Select;

const uploadButton = (
    <div>
        <PlusOutlined />
        <div className="upload-button-text">업로드</div>
    </div>
);

class BlogThird extends Component {
    constructor(props) {
        super(props);
        this.state = {
            thumbnailImage: [],
        };
    }

    state = {
        thumbnailImage: [],
    };

    handleThumbnailImageChange = ({thumbnailImage}) => this.setState({thumbnailImage});

    render() {
        const {getFieldDecorator} = this.props.form;
        const thumbnailUploadProps = {
            action: 'https://www.mocky.io/v2/5185415ba171ea3a00704eed',
            listType: 'picture-card',
            // fileList: this.state.thumbnailImage,
            // onChange: this.handleThumbnailImageChange,
            onChange: info => {
                const status = info.file.status;
                if (status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
            },
            multiple: false,
        };
        return (
            <div>
                <Row gutter={24}>
                    <Col span={12}>
                        <Divider>썸네일 업로드</Divider>
                        <Form.Item>
                            {getFieldDecorator("thumbnail-image")(
                                <Upload {...thumbnailUploadProps}>
                                    {this.state.thumbnailImage.length >= 1 ? null : uploadButton}
                                </Upload>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Divider>카테고리 설정</Divider>
                        <Form.Item>
                            {getFieldDecorator("category")(
                                <Select style={{width: 250}}>
                                    <Option value="one">일번</Option>
                                    <Option value="two">이번</Option>
                                    <Option value="three">삼번</Option>
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Divider>폴더 설정</Divider>
                            {getFieldDecorator("folder")(
                                <Select style={{width: 250}}>
                                    <Option value="one">일번</Option>
                                    <Option value="two">이번</Option>
                                    <Option value="three">삼번</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Form.create()(BlogThird);